import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { onlyDefined } from '@amityeko/pbc-core/dist/utilities/style';
import styles from './styles';
/**
 * @slot - Icon (amityeko-icon is expected as the slot placeholder)
 *
 * @cssproperty --amityeko-icon-badge-bg-color - Color of the badge background.
 */
export default class AmityekoIconBadge extends LitElement {
    render() {
        return html `
      <div
        style=${styleMap(onlyDefined({
            '--private-bg-color': this.bgColor,
            '--private-container-size': this.containerSize,
        }))}
      >
        <slot></slot>
      </div>
    `;
    }
}
AmityekoIconBadge.styles = styles;
__decorate([
    property()
], AmityekoIconBadge.prototype, "containerSize", void 0);
__decorate([
    property()
], AmityekoIconBadge.prototype, "bgColor", void 0);
if (!customElements.get('amityeko-icon-badge')) {
    customElements.define('amityeko-icon-badge', AmityekoIconBadge);
}
//# sourceMappingURL=index.js.map